import React from 'react';
import { Skill } from '../types';

interface SkillTooltipProps {
  skill: Skill;
  visible: boolean;
  x: number;
  y: number;
  jobGcd?: number;
}

export const SkillTooltip: React.FC<SkillTooltipProps> = ({ skill, visible, x, y, jobGcd = 2.5 }) => {
  if (!visible) return null;

  const getSkillTypeText = () => {
    return '技能'; // 统一的技能分类
  };

  const getCastTimeText = (castTime?: number) => {
    if (!castTime || castTime === 0) return '即时';
    return `${castTime.toFixed(1)}秒`;
  };

  const getRecastTimeText = (recastTime?: number, gcd?: boolean) => {
    if (gcd) return `${jobGcd.toFixed(2)}秒`;
    if (!recastTime || recastTime === 0) return '无';
    return `${recastTime.toFixed(0)}秒`;
  };

  return (
    <div
      style={{
        position: 'fixed',
        left: x + 10,
        top: y - 10,
        backgroundColor: 'rgba(42, 42, 42, 0.95)',
        border: '2px solid #D4AF37',
        borderRadius: '8px',
        padding: '12px',
        minWidth: '280px',
        maxWidth: '350px',
        color: 'white',
        fontSize: '13px',
        fontFamily: 'Arial, sans-serif',
        zIndex: 1000,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.8)',
        pointerEvents: 'none'
      }}
    >
      {/* 技能名称和图标 */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        {skill.icon && (
          <img
            src={skill.icon}
            alt={skill.name}
            style={{
              width: '40px',
              height: '40px',
              marginRight: '12px',
              borderRadius: '4px',
              border: '1px solid #666'
            }}
          />
        )}
        <div>
          <div style={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: '#FFE4B5',
            marginBottom: '2px'
          }}>
            {skill.name}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#D4AF37',
            marginBottom: '4px'
          }}>
            {getSkillTypeText()}
          </div>
          <div style={{
            fontSize: '11px',
            color: '#AAA'
          }}>
            距离{skill.range || 25}米　范围{skill.aoeRange || 0}米
          </div>
        </div>
      </div>

      {/* 咏唱和复唱时间 */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between',
        marginBottom: '12px',
        paddingBottom: '8px',
        borderBottom: '1px solid #555'
      }}>
        <div>
          <div style={{ color: '#AAA', fontSize: '11px' }}>咏唱时间</div>
          <div style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>
            {getCastTimeText(skill.castTime)}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ color: '#AAA', fontSize: '11px' }}>复唱时间</div>
          <div style={{ color: 'white', fontSize: '14px', fontWeight: 'bold' }}>
            {getRecastTimeText(skill.recastTime, skill.gcd)}
          </div>
        </div>
      </div>

      {/* 技能描述 */}
      <div style={{ marginBottom: '8px', lineHeight: '1.4' }}>
        {skill.description}
      </div>

      {/* 技能效果 */}
      {skill.effects && skill.effects.length > 0 && (
        <div style={{ marginBottom: '8px' }}>
          {skill.effects.map((effect, index) => (
            <div key={index} style={{ marginBottom: '4px' }}>
              {effect.type === 'proc' && (
                <div style={{ color: '#90EE90' }}>
                  追加效果（发动几率{effect.value}%）：
                  <span style={{ color: '#FFE4B5', marginLeft: '4px' }}>
                    {effect.effectName || effect.description}
                  </span>
                  {effect.duration && (
                    <div style={{ color: '#90EE90', fontSize: '11px' }}>
                      持续时间：{effect.duration}秒
                    </div>
                  )}
                </div>
              )}
              {effect.type === 'buff' && (
                <div style={{ color: '#87CEEB' }}>
                  附加效果：
                  <span style={{ color: '#FFE4B5', marginLeft: '4px' }}>
                    {effect.effectName || effect.description}
                  </span>
                  {effect.duration && (
                    <div style={{ color: '#87CEEB', fontSize: '11px' }}>
                      持续时间：{effect.duration}秒
                    </div>
                  )}
                </div>
              )}
              {effect.type === 'debuff' && (
                <div style={{ color: '#F08080' }}>
                  附加效果：
                  <span style={{ color: '#FFE4B5', marginLeft: '4px' }}>
                    {effect.effectName || effect.description}
                  </span>
                  {effect.duration && (
                    <div style={{ color: '#F08080', fontSize: '11px' }}>
                      持续时间：{effect.duration}秒
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* 发动条件 */}
      {skill.requirements && skill.requirements.length > 0 && (
        <div style={{ 
          color: '#DDD', 
          fontSize: '11px',
          marginTop: '8px',
          paddingTop: '8px',
          borderTop: '1px solid #555'
        }}>
          发动条件：
          {skill.requirements.map((req, index) => (
            <span key={index} style={{ color: '#FFB347', marginLeft: '4px' }}>
              {req.condition}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};